import React, { useCallback, useEffect, useMemo, useState } from "react"
import { formatDateString, formatDateTimeLocalDate, romanNum } from "../../../utilities/Utils"
import UPT from "../../../utilities/UPT"
import { Button, Col, Form, OverlayTrigger, Row, Spinner, Tooltip } from "react-bootstrap"
import { FaBars, FaCopy, FaEdit, FaEye, FaMinus, FaPaperPlane, FaPlus, FaTrash } from "react-icons/fa"
import NonlalinService from "../../../services/nonlalin/NonlalinService"
import UserService from "../../../services/user/UserService"
import Card from "../../../components/Card"
import { AsyncPaginate } from "react-select-async-paginate"
import DataTable from "react-data-table-component"
import { useNavigate } from "react-router-dom"
import NonlalinMaksudKegiatan from "../../../utilities/nonlalin/NonlalinMaksudKegiatan"
import NonlalinStatus from "../../../utilities/nonlalin/NonlalinStatus"
import ModalLog from "../modal/ModalLog"
import SweetAlert from "react-bootstrap-sweetalert"
import PbUmkuService from "../../../services/pbumku/PbumkuService"
import ExpandableComponentNonLalin from "../expand/ExpandableComponentNonLalin"

const DraftNonLalin = () => {

    const columns = [
        {
            name: 'Nomor Aju',
            cell: row => row['nomorAju'],
            grow: 0.4
        },
        {
            name: 'Tanggal Aju',
            cell: row => formatDateTimeLocalDate(row['tanggalAju']),
            grow: 0.3
        },
        {
            name: 'UPT',
            cell: row => (<>{row['kodeUpt']} - <UPT id={row['kodeUpt']} /></>),
            grow: 0.5
        },
        {
            name: 'Nama',
            cell: row => row['namaTrader'],
            grow: 0.5
        },
        {
            name: 'Maksud Kegiatan',
            cell: row => <NonlalinMaksudKegiatan id={row['maksudKegiatan']} />,
            grow: 0.5
        },
        {
            name: 'Peruntukan',
            cell: row => row['peruntukan'] === '1' ? 'Konsumsi' : 'Non Konsumsi',
            grow: 0.25
        },
        {
            name: 'Tanggal Masuk Sample',
            cell: row => formatDateString(row['tanggalMasukSample']),
            grow: 0.5
        },
        {
            name: 'Status',
            cell: row => <NonlalinStatus kodeStatus={row['status']} />,
            grow: 0.3
        },
        {
            name: 'Action',
            cell: row => (
                <>
                    <div className="row">
                        <div className="col-12 mb-1">
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Lihat Permohonan</Tooltip>}>
                                <Button size="sm" variant="info" onClick={() => ViewDok(row['nomorAju'], '0')}>
                                    <FaEye /> Lihat
                                </Button>
                            </OverlayTrigger>{' '}
                        </div>
                        <div className="col-12 mb-1">
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Ubah Permohonan</Tooltip>}>
                                <Button size="sm" variant="warning" onClick={() => ViewDok(row['nomorAju'], '1')}>
                                    <FaEdit /> Ubah
                                </Button>
                            </OverlayTrigger>{' '}
                        </div>
                        <div className="col-12 mb-1">
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Hapus Permohonan</Tooltip>}>
                                <Button size="sm" variant="danger" onClick={() => HapusDok(row)}>
                                    <FaTrash /> Hapus
                                </Button>
                            </OverlayTrigger>{' '}
                        </div>
                        <div className="col-12 mb-1">
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Kirim Permohonan</Tooltip>}>
                                <Button size="sm" variant="primary" onClick={() => SendDok(row)}>
                                    <FaPaperPlane /> Kirim
                                </Button>
                            </OverlayTrigger>{' '}
                        </div>
                        <div className="col-12 mb-1">
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Duplikat Permohonan</Tooltip>}>
                                <Button size="sm" variant="light" onClick={() => CopyPermohonan(row)}>
                                    <FaCopy /> Copy
                                </Button>
                            </OverlayTrigger>{' '}
                        </div>
                        <div className="col-12 mb-1">
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >History Permohonan</Tooltip>}>
                                <Button size="sm" variant="secondary" onClick={() => ViewLogStatus(row)}>
                                    <FaBars /> History
                                </Button>
                            </OverlayTrigger>{' '}
                        </div>
                    </div>
                </>
            ),
            grow: 0.5
        }
    ]

    let nonLalinService = useMemo(() => new NonlalinService(), [])
    let userService = useMemo(() => new UserService(), [])

    const [listData, setListData] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const getListData = useCallback(async (page, size) => {
        setLoading(true)
        try {
            let response = null;
            if (localStorage.getItem("kodeTrader") !== null) {
                const trader = await userService.getTraderById(localStorage.getItem("kodeTrader"))
                response = await nonLalinService.listNonlalinPerUpt(null, trader.data.npwp, null, '000', page, size)
            } else {
                response = await nonLalinService.listNonlalinPerUpt(null, null, null, '000', page, size)
            }
            setListData(response.data.data)
            setTotalData(response.data.totalData)
        } catch (error) {
            setListData([])
        }
        setLoading(false)
    }, [nonLalinService, userService])

    useEffect(() => {
        getListData(0, 10)
    }, [getListData])

    const handleChangePage = (page) => {
        getListData(page - 1, size)
    }

    const handlePerRowsChange = async (size, page) => {
        let _res = null
        if (localStorage.getItem("kodeTrader") !== null) {
            const trader = await userService.getTraderById(localStorage.getItem("kodeTrader"))
            _res = await nonLalinService.listNonlalinPerUpt(null, trader.data.npwp, null, '000', page - 1, size)
        } else {
            _res = await nonLalinService.listNonlalinPerUpt(null, null, null, '000', page - 1, size)
        }
        setListData(_res.data.data)
        setSize(size)
    }

    const handleClickReset = () => {
        setValueSearchAju('')
        setValueUptOpt(null)
        getListData(0, 10)
    }

    const handleClickCari = async (page, size) => {
        let _res = null
        if (localStorage.getItem("kodeTrader") !== null) {
            const trader = await userService.getTraderById(localStorage.getItem("kodeTrader"))
            _res = await nonLalinService.listNonlalinPerUpt(valueSearchAju !== null ? valueSearchAju : null, trader.data.npwp, valueUptOpt !== null ? valueUptOpt.kdUnit : null, '000', page - 1, size)
        } else {
            _res = await nonLalinService.listNonlalinPerUpt(valueSearchAju !== null ? valueSearchAju : null, null, valueUptOpt !== null ? valueUptOpt.kdUnit : null, '000', page - 1, size)
        }
        setListData(_res.data.data)
        setSize(size)
    }

    const [valueSearchAju, setValueSearchAju] = useState(null)
    const onChangeSearchAju = e => {
        setValueSearchAju(e.target.value)
    }

    const [valueUptOpt, setValueUptOpt] = useState(null)
    async function loadOptionUpt(search, loadedOption, { page = 1 }) {
        const response = await userService.listUpt(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangeUpt = e => {
        setValueUptOpt(e)
    }

    const navigate = useNavigate();

    const TambahBaru = () => {
        localStorage.removeItem('isEditStorage')
        localStorage.removeItem('nomorAjuStorage')
        localStorage.removeItem('dataHeaderStorage')
        localStorage.removeItem('dataDetailStorage')
        localStorage.removeItem('dataDokumenStorage')
        localStorage.removeItem('dataKemasanStorage')
        localStorage.setItem('isEditStorage', '1')
        navigate('/nonlalin/view')
    }

    const ViewDok = (noAju, isEdit) => {
        localStorage.removeItem('isEditStorage')
        localStorage.removeItem('nomorAjuStorage')
        localStorage.setItem('nomorAjuStorage', noAju)
        localStorage.setItem('isEditStorage', isEdit)
        navigate('/nonlalin/view')
    }

    const [showConfirmHapus, setShowConfirmHapus] = useState(false)
    const handleCloseConfirmHapus = () => setShowConfirmHapus(false)
    const [showHapusSuccess, setShowHapusSucces] = useState(false)
    const [showHapusFailed, setShowHapusFailed] = useState(false)
    const [loadingHapus, setLoadingHapus] = useState(false)

    const HapusDok = (rowdata) => {
        setShowConfirmHapus(true)
        setRowData(rowdata)
    }

    const handleClickHapus = async () => {
        setLoadingHapus(true)
        try {
            let jsonHapusData = { ...rowData, status: '120' }

            const response = await nonLalinService.saveNonlalinHeader(JSON.stringify(jsonHapusData))
            if (response.data.kode === '200') {
                let dataStatus = {
                    nomorAju: rowData.nomorAju,
                    kodeStatus: '120',
                    waktuStatus: new Date(),
                    createdBy: localStorage.getItem('username')
                }
                await nonLalinService.saveNonlalinStatus(JSON.stringify(dataStatus))
                setShowHapusSucces(true)
                setShowConfirmHapus(false)
            } else {
                setShowHapusFailed(true)
            }
        } catch (error) {
            setShowHapusFailed(true)
        }
        setLoadingHapus(false)
    }

    const handleClickHapusSuccess = () => {
        setShowHapusSucces(false)
        getListData(0, 10)
    }

    const handleClickHapusFailed = () => {
        setShowHapusFailed(false)
    }

    const [rowData, setRowData] = useState(null)
    const [showLog, setShowLog] = useState(false)
    const handleCloseLog = () => setShowLog(false)

    const ViewLogStatus = (rowdata) => {
        setRowData(rowdata)
        setShowLog(true)
    }

    const [showConfirmSend, setShowConfirmSend] = useState(false)
    const handleCloseConfirmSend = () => setShowConfirmSend(false)
    const [showSendSuccess, setShowSendSucces] = useState(false)
    const [showSendFailed, setShowSendFailed] = useState(false)
    const [loadingSend, setLoadingSend] = useState(false)

    const SendDok = (rowdata) => {
        setShowConfirmSend(true)
        setRowData(rowdata)
    }

    const handleClickSend = async () => {
        setLoadingSend(true)
        // setShowConfirmSend(false)
        try {
            // console.log(rowData)
            let jsonKirimData = { ...rowData, status: '010' }

            const response = await nonLalinService.saveNonlalinHeader(JSON.stringify(jsonKirimData))
            if (response.data.kode === '200') {
                setShowSendSucces(true)
                setShowConfirmSend(false)

                let dataStatus = {
                    nomorAju: rowData.nomorAju,
                    kodeStatus: '010',
                    waktuStatus: new Date(),
                    createdBy: localStorage.getItem('username')
                }
                await nonLalinService.saveNonlalinStatus(JSON.stringify(dataStatus))

                let jsonDisposisi = {
                    idDisposisi: 1,
                    nomorAju: rowData.nomorAju,
                    createdAt: new Date()
                }
                await nonLalinService.saveNonlalinPenugasan(jsonDisposisi)
            } else {
                setShowSendFailed(true)
            }
        } catch (error) {
            setShowSendFailed(true)
        }
        // console.log(noAju)
        setLoadingSend(false)
    }

    const handleClickSendSuccess = () => {
        setShowSendSucces(false)
        getListData(0, 10)
    }

    const handleClickSendFailed = () => {
        setShowSendFailed(false)
    }

    let pbumkuService = useMemo(() => new PbUmkuService(), [])

    const currentDate = new Date()
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()

    const [showConfirmCopy, setShowConfirmCopy] = useState(false)
    const handleCloseConfirmCopy = () => setShowConfirmCopy(false)
    const [loadingCopy, setLoadingCopy] = useState(false)
    const [showCopySuccess, setShowCopySucces] = useState(false)
    const [showCopyFailed, setShowCopyFailed] = useState(false)
    const [newAju, setNewAju] = useState(null)

    const CopyPermohonan = (rowdata) => {
        setRowData(rowdata)
        setShowConfirmCopy(true)
    }

    const handleClickCopy = async () => {
        setLoadingCopy(true)
        try {
            const respNomor = await pbumkuService.ambilNomorService('NLL_AJU', rowData.kodeUpt, currentYear, localStorage.getItem('username'))
            let nomorAjuBaru = respNomor.data.uraianPusat + respNomor.data.kodePusat + romanNum(currentMonth) + currentYear + respNomor.data.nomorUrut

            const response = await nonLalinService.copyPermohonan(rowData.nomorAju, nomorAjuBaru)
            if (response.data.kode === '200') {
                setNewAju(response.data.id)
                setShowCopySucces(true)
                setShowConfirmCopy(false)
            } else {
                setShowCopyFailed(true)
            }
        } catch (error) {
            setShowCopyFailed(true)
        }
        setLoadingCopy(false)
    }

    const handleClickCopySuccess = () => {
        setShowCopySucces(false)
        getListData(0, 10)
    }

    const handleClickCopyFailed = () => {
        setShowCopyFailed(false)
    }

    return (
        <>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Pencarian Data</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="row">
                                <div className="col-sm-3">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">No. Aju</Form.Label>
                                            <Col sm="9">
                                                <Form.Control type="searchNib" placeholder="Nomor Aju" className="form-control-sm" value={valueSearchAju} onChange={onChangeSearchAju} />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                                <div className="col-sm-4">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">UPT</Form.Label>
                                            <Col sm="10">
                                                <AsyncPaginate
                                                    loadOptions={loadOptionUpt}
                                                    value={valueUptOpt}
                                                    getOptionValue={(option) => option.kdUnit}
                                                    getOptionLabel={(option) => option.nmUnit}
                                                    additional={{
                                                        page: 1,
                                                    }}
                                                    onChange={onChangeUpt}
                                                />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Col sm="2">
                                                <Button type="button" variant="btn btn-primary" size="sm" onClick={() => handleClickCari(0, 10)}>Cari</Button>{' '}
                                                <Button type="button" variant="btn btn-danger" size="sm" onClick={() => handleClickReset()}>Reset</Button>{' '}
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Draft Permohonan Layanan Laboratorium & Jasa Lainnya</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <Button type="button" variant="primary" size="sm" onClick={() => TambahBaru()}><FaPlus /> Tambah</Button>
                            <div className="table-responsive border-bottom my-3">
                                {(loading && <Spinner />)}
                                <DataTable
                                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                    columns={columns}
                                    data={listData}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalData}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    persistTableHead={true}
                                    expandableRows
                                    expandOnRowDoubleClicked
                                    expandableIcon={{
                                        collapsed: <FaPlus size={12} color="blue" />, // Custom expand icon
                                        expanded: <FaMinus size={12} color="red" />,   // Custom collapse icon
                                    }}
                                    expandableRowsComponent={({ data }) => <ExpandableComponentNonLalin data={data} />}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ModalLog showLog={showLog} handleCloseLog={handleCloseLog} datappm={rowData} />
            {
                showConfirmSend &&
                <SweetAlert
                    title="Kirim Permohonan?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSend ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Kirim...
                            </>
                        ) : (
                            "Kirim"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSend}
                    onCancel={handleCloseConfirmSend}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                    disabled={loadingSend}
                >
                    {loadingSend && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Kirim data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSendSuccess &&
                <SweetAlert
                    success
                    title="Kirim Data Berhasil"
                    onConfirm={handleClickSendSuccess}
                    btnSize="sm"
                />
            }
            {
                showSendFailed &&
                <SweetAlert
                    danger
                    title="Kirim Data Gagal"
                    onConfirm={handleClickSendFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
            {
                showConfirmHapus &&
                <SweetAlert
                    title="Hapus Permohonan?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingHapus ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Hapus...
                            </>
                        ) : (
                            "Hapus"
                        )
                    }
                    confirmBtnBsStyle="danger"
                    cancelBtnText="Kembali"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickHapus}
                    onCancel={handleCloseConfirmHapus}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                >
                    {loadingHapus && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Hapus, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showHapusSuccess &&
                <SweetAlert
                    success
                    title="Hapus Permohonan Berhasil"
                    onConfirm={handleClickHapusSuccess}
                    btnSize="sm"
                />
            }
            {
                showHapusFailed &&
                <SweetAlert
                    danger
                    title="Hapus Permohonan Gagal"
                    onConfirm={handleClickHapusFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
            {
                showConfirmCopy &&
                <SweetAlert
                    title="Copy Permohonan?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingCopy ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Copy...
                            </>
                        ) : (
                            "Copy"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Kembali"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickCopy}
                    onCancel={handleCloseConfirmCopy}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                >
                    {loadingCopy && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Copy data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showCopySuccess &&
                <SweetAlert
                    success
                    title="Copy Data Berhasil"
                    onConfirm={handleClickCopySuccess}
                    btnSize="sm"
                >Nomor Aju Baru : {newAju}</SweetAlert>
            }
            {
                showCopyFailed &&
                <SweetAlert
                    danger
                    title="Copy Data Gagal"
                    onConfirm={handleClickCopyFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default DraftNonLalin